module.exports = function($stateProvider) {
  $stateProvider.state('billing', {
    parent: 'root',
    abstract: true,
    onEnter: ['editPaymentModal', editPaymentModal => editPaymentModal.open()],
    params: {
      shipment: {}
    }
  });
};

module.exports.$inject = ['$stateProvider'];
